export default "__VITE_ASSET__a309917b__"